'use client'

import React, { ReactElement } from 'react'
import { useTranslations } from 'next-intl'

interface FilterLabelProps {
  label: string
}

export default function FilterLabel(props: FilterLabelProps): ReactElement {
  const t = useTranslations()
  return <div className="mb-4 text-left text-3xl font-medium text-stone-800">{t(props.label)}</div>
}
